// extracted by mini-css-extract-plugin
export default {"section":"SectionBackground_section__EPeNi","section_content":"SectionBackground_section_content__hOE3G"};